import Header from "./Header";
import Footer from "./Footer";
import React from "react";
import ScrollToTop from "../Helper/ScrollToTop";

const Privacy = () => {
    return (
        <>
            <ScrollToTop/>
            <Header/>

            <div className="container" id="start">

                <h1>Datenschutzerklärung</h1>

                <h3>1. Datenschutz auf einen Blick</h3>

                <h4>Allgemeine Hinweise</h4>
                <p> Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                    personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
                    Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
                    werden können.
                </p>

                <h4>Datenerfassung auf dieser Website</h4>
                <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.
                    Dessen Kontaktdaten können Sie dem Impressum dieser Website bzw. dem
                    folgenden Abschnitt „Hinweis zur verantwortlichen Stelle“ entnehmen.
                    Die Erfassung Ihrer Daten erfolgt einerseits dadurch, dass Sie uns diese mitteilen (z.
                    B. per E-Mail). Andere Daten werden automatisch oder nach Ihrer Einwilligung beim
                    Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische
                    Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
                    Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.</p>

                <h3>2. Verantwortliche Stelle</h3>
                <p> Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br/>
                    Michaela Diener<br/>
                    Dr.-Rudi-Moser-Str. 15<br/>
                    99510 Apolda<br/>
                    Telefon: 0151 / 56155457<br/>
                    E-Mail: info@spb-apolda.de<br/>
                    Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
                    gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
                    personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                </p>

                <h3>3. Ihre Rechte (Betroffenenrechte)</h3>
                <p> Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und
                    Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben
                    außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
                    Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese
                    Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
                    unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
                    personenbezogenen Daten zu verlangen oder Beschwerde bei der zuständigen
                    Datenschutz-Aufsichtsbehörde einzulegen.
                </p>

                <h3>4. Datenerfassung und allgemeine Pflichtinformationen
                    SSL- bzw. TLS-Verschlüsselung</h3>
                <p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
                    vertraulicher Inhalte, wie zum Beispiel Anfragen, die Sie an uns als Seitenbetreiber
                    senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
                    erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“
                    wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                </p>
                <h4>Server-Log-Files</h4>
                <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in
                    sogenannten Server-Log-Files, die Ihr Browser automatisch an uns übermittelt. Dies
                    sind:<br/>
                    <ul>
                        <li>Browsertyp und Browserversion</li>
                        <li>Verwendetes Betriebssystem</li>
                        <li>Referrer URL (die zuvor besuchte Seite)</li>
                        <li>Hostname des zugreifenden Rechners</li>
                        <li>Uhrzeit der Serveranfrage</li>
                        <li>IP-Adresse</li>
                    </ul>
                    Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
                    vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
                    f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch
                    fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die
                    Server-Logfiles erfasst werden.
                </p>
                <h4>Anfragen per E-Mail oder Telefon</h4>
                <p>Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller
                    daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke
                    der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten
                    geben wir nicht ohne Ihre Einwilligung weiter.
                    Die Verarbeitung dieser Anfragen erfolgt basierend auf Art. 6 Abs. 1 lit. b DSGVO bei
                    vertragsbezogenen Anliegen, ansonsten auf Basis unseres berechtigten Interesses
                    an einer effektiven Bearbeitung (Art. 6 Abs. 1 lit. f DSGVO) oder einer
                    entsprechenden Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</p>
            </div>

            <Footer/>
        </>
    );
};
export default Privacy;
